import { Middleware } from 'redux'

import { trackCreateTimer, createTimerActions } from './trackers'

export const segmentMiddleware: Middleware =
  ({ getState }) =>
  next =>
  action => {
    if (createTimerActions.has(action.type)) {
      trackCreateTimer(action, getState())
    }

    next(action)
  }
